<ng-template #deleteMenuItemModal let-modal>
    <div class="modal-body">
        <h2>Sure want to delete it?</h2>
        <h5 class="food-dish-name">{{dishName}}</h5>
        <div class="btn-grps">
            <app-button  [btnText]="'Cancel'" [btnTitle]="'Cancel'" [btnCss]="'btn btn-outline-primary'" (onBtnClick)="modal.close('Close click')"></app-button>
            <app-button  [btnText]="'Delete'" [btnTitle]="'Delete'" [btnCss]="'btn btn-primary'" (onBtnClick)="deleteDish(id, imageId);modal.close('Close click');"></app-button>
        </div>
    </div>
</ng-template>